// ESLint rule disabled intentionally (false positive).
/* eslint-disable @next/next/no-html-link-for-pages */
// NOTE: Next linting rules might suggest using the Link component instead of an anchor tag.
// The Link component is meant to perform client-side transitions between pages.
// As the link points to an API route and not to a page, you should keep it as an anchor tag.
// https://auth0.com/docs/quickstart/webapp/nextjs#add-login-to-your-application
// Also, button with router.push() cannot be used, auth0 will not work.
'use client'

import Head from 'next/head'
import { useUser } from '@auth0/nextjs-auth0'
import { className } from '@/components/common/styles'
import { Anonymous, Signup } from '@/components/auth/Auth'

const Auth = () => {
  const { user, error, isLoading } = useUser()
  return (
    <>
      <Head>
        <title>Auth</title>
        <meta name="description" content="Auth" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <h1 className="text-2xl font-bold">Auth</h1>
      {error ? <div>{error.message}</div> : <div>no errors</div>}
      {isLoading ? <div>loading...</div> : <div>ready</div>}
      {user && <div>Welcome {user.name}</div>}
      {user ? (
        <div className={`${className} w-24 justify-center`}>
          <a href="/auth/logout">Logout</a>
        </div>
      ) : (
        <div>
          <Anonymous />
          <Signup />
        </div>
      )}
    </>
  )
}

export default Auth
